import { axios } from "../config";

export function getNotificationList(page, pageSize) {
  return axios.get(`/api/v1/notifications?page=${page}&pageSize=${pageSize}`);
}
export function getNotificationListCount() {
  return axios.get(`api/v1/notifications/count`);
}
